import jQuery from 'jquery';
import initOdds from '../oddsTabHandler';

const outcomersIdAttr = 'data-diffusion-outcomers-id';
const meetingIdAttr = 'data-diffusion-meeting-id';

const clickHandler = ({ target }) => {
    const linkOutcomersId = jQuery(target).attr(outcomersIdAttr);
    const linkMeetingId = jQuery(target).attr(meetingIdAttr);
    const $oddsLink = jQuery(window.opener.document).find(
        `[${outcomersIdAttr}="${linkOutcomersId}"][${meetingIdAttr}="${linkMeetingId}"]`
    );

    if ($oddsLink.length) {
        $oddsLink.get(0).click();
    }

    window.close();
};

const variant4popup = () => {
    jQuery(document).ready(() => {
        if (!jQuery('.js-odds-popup-window').length) { return; }

        initOdds();
        jQuery(document)
            .on('click', 'a.RC-oddsRunnerContent__price', clickHandler);
    });
};

export default variant4popup;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/variant4popup.js